import { BaseApi } from '.';
const pendingRequests = new Map();
const pendingThermalDataRequests = new Map();

export const ExamineOutputApi = {
  getThermalData,
  getThermalImages
};

function getThermalData(thermalImageId) {
  const requestKey = `${thermalImageId}`;

  if (pendingThermalDataRequests.has(requestKey)) {
    return pendingThermalDataRequests.get(requestKey);
  }

  const requestPromise = BaseApi.get(`/examine/output/thermal/data/${thermalImageId}`)
    .finally(() => {
      pendingThermalDataRequests.delete(requestKey);
    });

  pendingThermalDataRequests.set(requestKey, requestPromise);
  return requestPromise;
}
function getThermalImages(reportId, showAiDefectFlag, axiosConfig) {
  const url = `/solar-thermal-images/reportId/${reportId}?showAiDefect=${showAiDefectFlag}`;

  // 다이얼로그 등 signal 기반 취소는 dedup 없이 독립 요청
  if (axiosConfig?.signal) {
    return BaseApi.get(url, axiosConfig);
  }

  const requestKey = `${reportId}_${showAiDefectFlag}`;

  // 요청 중인지 확인
  if (pendingRequests.has(requestKey)) {
    console.log('이미 요청 중입니다. 기다리세요.');
    return pendingRequests.get(requestKey); // 기존 요청 Promise 반환
  }

  // 새로운 요청 생성
  const requestPromise = BaseApi.get(url).finally(() => {
    // 요청 완료 시 상태 제거
    pendingRequests.delete(requestKey);
  });

  // 요청 상태 저장
  pendingRequests.set(requestKey, requestPromise);

  return requestPromise;
}
